import {CalculatorBase} from "./CalculatorBase";

export class CurrentValueCalculator extends CalculatorBase{

    public ExecuteCalculation(value:any):{RegularPrice:any,SalePrice:any,Quantity:number}  {
        if(value==null)
            value=this.Field.GetValue();
        if(value.trim()=='')
            return {SalePrice:'',RegularPrice:'',Quantity:0};

        if(isNaN(parseFloat(value)))
            return {RegularPrice: '',SalePrice:'',Quantity:0};
        else
            return {RegularPrice:value,Quantity: this.GetQuantityInput(),SalePrice:''};
    }

    public ParseNumber(number:any)
    {
        let num=parseFloat(number);
        if(isNaN(num))
            return 0;
        return num;
    }

}